import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { FabricSqlTableDataset } from 'shell-models-lib';
import { SqlServerCopySource } from './sql-server.copysource';
@Metamodel.model({
    name: adfModelTypeMap.fabricSql.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(FabricSqlTableDataset) }
})
export class FabricSqlCopySource extends SqlServerCopySource {}
